// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3Rx8y","author":"Footer_author__170at","brand":"Footer_brand__1e-9m","icons":"Footer_icons__2_ILs"};